import { useMemo } from 'react'

import { useIntl } from 'react-intl'

import { CarouselTagItem } from 'components/atoms/CarouselTag'
import { domainLocales } from 'domainLocales'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { assetImagePath, basePath } from 'interfaces/constants'
import { Category } from 'interfaces/types'

export type THomeCategoryItem = CarouselTagItem & {
  isNew?: boolean
}
export function useHomeCategory(props: {
  categories: Category[]
  maxItems?: number
}) {
  const { categories, maxItems = 6 } = props
  const { locale } = useRouterExtend()
  const { formatMessage: f } = useIntl()

  /** Category Carousel Item */
  const carouselItemsCategory = useMemo(() => {
    const carouselItems = categories.slice(0, maxItems)?.map((cat) => {
      const item: CarouselTagItem = {
        title: cat.displayName,
        icon: cat.iconUrl,
        href: `https://${domainLocales[locale]}${basePath}${cat.permalink}`,
        itemProps: {
          'data-event-category': 'Recommended Topics',
          'data-event-action': 'Click',
          'data-event-label': `https://${domainLocales[locale]}${basePath}${cat.permalink}`,
        },
      }
      return item
    })
    carouselItems.unshift({
      title: f({
        id: 'home.seeAllCategories',
        defaultMessage: 'See All',
      }),
      icon: `${assetImagePath}/all-categories.png`,
      href: `https://${domainLocales[locale]}${basePath}/categories`,
      itemProps: {
        'data-event-category': 'Recommended Topics',
        'data-event-action': 'See All Click',
        'data-event-label': `https://${domainLocales[locale]}${basePath}/categories`,
      },
    })
    return carouselItems
  }, [categories])

  return useMemo(() => ({ carouselItemsCategory }), [carouselItemsCategory])
}
